import React, { FC } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import { useDossieService } from '../../use-cases/dossie';

export const CobrancaAlertContainer: FC = () => {
  const { cobrancaAlert, fecharCobrancaAlert, confirmarCobrancaAlert, loading } = useDossieService();

  if (!cobrancaAlert) return null;

  return (
    <Dialog
      open={cobrancaAlert.open}
      onClose={loading ? undefined : () => fecharCobrancaAlert()}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '16px', p: 1 } }}
    >
      <DialogContent sx={{ textAlign: 'center', pt: 3 }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: '#f3eff7',
            color: '#723989',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <PaidOutlinedIcon fontSize="large" />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b', mb: 1 }}>
          Esta consulta será cobrada
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b' }}>
          Ao prosseguir será contabilizado como uma nova consulta. Deseja continuar?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2, gap: 1 }}>
        <Button
          onClick={fecharCobrancaAlert}
          disabled={loading}
          sx={{ color: '#64748b', textTransform: 'none', fontWeight: 600 }}
        >
          Cancelar
        </Button>
        <Button
          onClick={confirmarCobrancaAlert}
          disabled={loading}
          variant="contained"
          sx={{
            backgroundColor: '#723989',
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            '&:hover': { backgroundColor: '#562768' },
          }}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Estou de acordo'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
